import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=2c912b11&scoped=true&lang=pug&"
var script = {}
import style0 from "./protocol.vue?vue&type=style&index=0&id=2c912b11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c912b11",
  null
  
)

export default component.exports